import home from './components/Home.vue';
import reasons from './components/reason/Reasons.vue';
import newReason from './components/reason/NewReason.vue';
import editReason from './components/reason/EditReason.vue';
import projects from './components/project/Projects.vue';
import newProject from './components/project/NewProject.vue';
import editProject from './components/project/EditProject.vue';
import companies from './components/company/Companies.vue';
import newCompany from './components/company/NewCompany.vue';
import editCompany from './components/company/EditCompany.vue';
import users from './components/user/Users.vue';
import newUser from './components/user/NewUser.vue';
import editUser from './components/user/EditUser.vue';
import employees from './components/employee/Employees.vue';
import newEmployee from './components/employee/NewEmployee.vue';
import editEmployee from './components/employee/EditEmployee.vue';
import history from './components/history/History.vue';
import exportList from './components/export/ExportList.vue';
import exportSetup from './components/export/ExportSetup.vue';
import exportProcess from './components/export/ExportProcess.vue';
import exportVerify from './components/export/ExportVerify.vue';
import clockingAnalysis from './components/analysis/ClockingAnalysis.vue';
import dailySecMonRpt from './components/report/DailySecMonRpt.vue';
import login from './components/Login.vue';
import forgotPassword from './components/ForgotPassword.vue';
import resetPassword from './components/ResetPassword.vue';
import geolocation from './components/geolocation/Geolocation.vue';
import newGeolocation from './components/geolocation/NewGeolocation.vue';
import editGeolocation from './components/geolocation/EditGeolocation.vue';
import integrationSetup from './components/integrationsetup/IntegrationSetup.vue';
import newIntegrationSetup from './components/integrationsetup/NewIntegrationSetup.vue';
import editIntegrationSetup from './components/integrationsetup/EditIntegrationSetup.vue';


export default [
    {
        path: '/:lang', component: login,
    },
    {
        path: '/:lang/login',
        name: 'login',
        component: login,
        meta: {
            guest: true
        }
    },
    {
        path: '/:lang/forgotpassword',
        name: 'forgotpassword',
        component: forgotPassword,
        meta: {
            guest: true
        }
    },
    {
        path: '/:lang/resetpassword/:token',
        name: 'resetpassword',
        component: resetPassword,
        meta: {
            guest: true
        }
    },
    {
        path: '/:lang/home',
        name: 'home',
        component: home,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/reason',
        component: reasons,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/reason/new',
        component: newReason,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/reason/edit/:id',
        component: editReason,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/project',
        component: projects,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/project/new',
        component: newProject,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/project/edit/:id',
        component: editProject,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/company',
        component: companies,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/company/new',
        component: newCompany,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/company/edit/:id',
        component: editCompany,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/user',
        component: users,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/user/new',
        component: newUser,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/user/edit/:id',
        component: editUser,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/employee',
        component: employees,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/employee/new',
        component: newEmployee,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/employee/edit/:id',
        component: editEmployee,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/history',
        component: history,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/export/list',
        component: exportList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/export/setup',
        component: exportSetup,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/export/process',
        component: exportProcess,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/export/verify',
        component: exportVerify,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/analysis',
        component: clockingAnalysis,
        meta: {
            requiresAuth: true
        }
    },
    { 
        path: '/:lang/dailysecmonrpt', 
        component: dailySecMonRpt,
        meta: {
            requiresAuth: true
        }
    },
    { 
        path: '/:lang/geolocation', 
        component: geolocation,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/geolocation/new',
        component: newGeolocation,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/geolocation/edit/:id',
        component: editGeolocation,
        meta: {
            requiresAuth: true
        }
    },
    { 
        path: '/:lang/integrationsetup', 
        component: integrationSetup,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/integrationsetup/new',
        component: newIntegrationSetup,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:lang/integrationsetup/edit/:id',
        component: editIntegrationSetup,
        meta: {
            requiresAuth: true
        }
    },
]



// WEBPACK FOOTER //
// ./src/routes.js